import { getJSON } from "../utils/json";

export default ({ staticBaseURL }) => ({
    async getCurrencyFormat(iso, currency) {
        return await getJSON(
            `${staticBaseURL}/currency/format/?iso=${iso}&currency=${currency}`
        );
    },
});
